export const USPS_GROUND_ADVANTAGE = {
  carrierCode: 'usps',
  serviceCode: 'usps_ground_advantage',
} as const;

export type UspsGroundAdvantage = typeof USPS_GROUND_ADVANTAGE;
